module.exports = __webpack_public_path__ + "img/pin-node.c5b632a4.png";